// extracted by mini-css-extract-plugin
export default {"content":"Profile_content__+1aMB"};